import {
    Component, Input, Output, EventEmitter, ChangeDetectionStrategy,
    CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, OnChanges, SimpleChanges, OnInit,
    ChangeDetectorRef,
    Inject
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

import { OrderByPipe } from '../../../pipes/order-by.pipe';
import { SHARED_IMPORTS } from '../../shared/shared-imports';
import { InlineEditorComponent } from '../../shared/inline-editor/inline-editor.component';

export interface LocationTreeNode {
    Id?: string;
    Name: string;
    NodeType?: number;
    NodeTypeStr: 'Site' | 'Room' | string;
    Children?: LocationTreeNode[];
    AnchoredUnitId?: string | null;
    AnchoredUsbCode?: string | null;
    unit?: { UnitId?: string; Title?: string; title?: string; titleUSB?: string } | null;
}

@Component({
    selector: 'app-location-tree',
    standalone: true,
    imports: [
        ...SHARED_IMPORTS,
        CommonModule,
        MatIconModule,
        OrderByPipe,
        InlineEditorComponent,
    ],
    templateUrl: 'components/location-unit-anchoring/location-tree/location-tree.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class LocationTreeComponent implements OnInit, OnChanges {
    @Input({ required: true }) node!: LocationTreeNode;
    @Input() siteLevelActive = false;
    @Input() readMode = false;
    @Input() operatorMode = false;

    // ---- Watch this input via a setter so we see every update ----
    private _assignableUnits: any[] = [];
    @Input() set assignableUnits(val: any[]) {
        this._assignableUnits = val ?? [];
        this.cdr.markForCheck(); // needed with OnPush
    }
    get assignableUnits() { return this._assignableUnits; }

    @Output() unanchor = new EventEmitter<any>();
    @Output() anchorSelected = new EventEmitter<{ unit: any; position: any }>();
    @Output() requestSelect = new EventEmitter<{ position: any }>(); // legacy

    collapsed = true;
    editingId: string | null = null;

    constructor(@Inject (ChangeDetectorRef) private cdr: ChangeDetectorRef) { }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['node']) {
        }
    }

    // Inline edit handlers
    startEdit(position: any, evt?: Event): void {
        if (evt) evt.stopPropagation();
        if (this.readMode) return;
        this.editingId = position?.Id ?? null;
    }

    // Presentation helpers (unchanged)
    getBordUnitLocClass(node: any): string {
        let bordClass = node?.Children ? 'bordLocUnitAnchPadding' : '';
        if (this.siteLevelActive) bordClass += ' siteLevelBord';
        return bordClass;
    }
    getLocUnitAnchIcon(position: any): string {
        if (position.AnchoredUnitId != null && position.AnchoredUsbCode != null) return 'check';
        if (position.AnchoredUnitId != null && position.AnchoredUsbCode == null) return 'check';
        if (position.AnchoredUnitId == null && position.AnchoredUsbCode != null) return 'link';
        return 'radio_button_unchecked';
    }
    shouldDisableIconChange(position: any): boolean {
        return this.readMode || (position.AnchoredUsbCode != null && this.operatorMode);
    }
    getLocUnitAnchIconStyle(position: any): string {
        let iconClass = '';
        if (position.AnchoredUnitId != null && position.AnchoredUsbCode != null) iconClass = 'green';
        else if (position.AnchoredUnitId != null) iconClass = 'yellow';
        else if (position.AnchoredUsbCode != null) iconClass = 'noUnit';
        else iconClass = 'noAnchor';
        if (this.shouldDisableIconChange(position)) iconClass += ' changeIcon';
        return iconClass;
    }
    getIconClassDependingOnRole(position: any): string {
        return this.shouldDisableIconChange(position) ? 'changeIcon' : '';
    }
    getIconClassDependingOnRoleUpdate(position: any): string {
        if (this.readMode) return 'readMode';
        if (position.AnchoredUsbCode != null && this.operatorMode) return 'operatorMode';
        return '';
    }
    checkUSB(position: any): string | undefined { return position.AnchoredUsbCode == null ? 'noUSBcode' : undefined; }
    checkUnit(position: any): string | undefined { return position.AnchoredUnitId == null ? 'noUSBcode' : undefined; }
    toggleCollapse(): void { this.collapsed = !this.collapsed; }
    trackById = (_: number, n: any) => n?.Id ?? n?.Name;
    cancelEdit() { this.editingId = null; }
    onInlineConfirm(selected: any, position: any) {
        this.editingId = null;
        this.anchorSelected.emit({ unit: selected, position });
    }
}
